import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class Contracts {
  getEquipments(idContract) {
    return axios
      .get(`${config["apiUrl"]}contracts/${idContract}/equipments`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getBusiness(contractId) {
    return axios
      .get(`${config["apiUrl"]}contracts/${contractId}/business`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  searchEquipments(term) {
    return axios
      .get(`${config["apiUrl"]}equipments/search/${term}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  searchContracts(term) {
    return axios
      .get(`${config["apiUrl"]}contracts/search/${term}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  toExpiring(months, filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = { ...params, ...filters.filters };
      }
      if (filters.sort != undefined) {
        params = { ...params, ...filters.sort };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/${months}`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  countToExpiring(months, filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = {...filters.filters };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/${months}/count`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getExpired(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = { ...params, ...filters.filters };
      }
      if (filters.sort != undefined) {
        params = { ...params, ...filters.sort };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expired`, {
      headers: authHeader(),
      params: params,
      })
      .then((response) => {
      if (response.status == 200) {
        return response.data;
      }
      return null;
      })
      .catch((error) => {
      if (error.response.status == 401) {
        AuthService.logout();
        window.location = "/login";
      }
      console.log("ERROR:: ", error.response.data);
      return null;
      });
  }
  countExpired(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = {...filters.filters };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expired/count`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  getWithoutInitialOrderNote(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = { ...params, ...filters.filters };
      }
      if (filters.sort != undefined) {
        params = { ...params, ...filters.sort };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/notInitialOrderNote`, {
      headers: authHeader(),
      params: params,
      })
      .then((response) => {
      if (response.status == 200) {
        return response.data;
      }
      return null;
      })
      .catch((error) => {
      if (error.response.status == 401) {
        AuthService.logout();
        window.location = "/login";
      }
      console.log("ERROR:: ", error.response.data);
      return null;
      });
  }
  countWithoutInitialOrderNote(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = {...filters.filters };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/notInitialOrderNote/count`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  getValid(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = { ...params, ...filters.filters };
      }
      if (filters.sort != undefined) {
        params = { ...params, ...filters.sort };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/valid`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  countValid(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = {...filters.filters };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/valid/count`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  getAll(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = { ...params, ...filters.filters };
      }
      if (filters.sort != undefined) {
        params = { ...params, ...filters.sort };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/all`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  getEmailsTypes() {
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/emailsType`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  sendMessage(contractId, formData) {
    let headers = authHeader();
    headers["Content-Type"] = "multipart/form-data";
    return axios
      .post(
        `${config["apiUrl"]}contracts/expiring/${contractId}/message`,
        formData,
        {
          headers: headers,
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  changeSeller(contractId, bodyparms) {
    return axios
      .patch(
        `${config["apiUrl"]}contracts/expiring/${contractId}/seller`,
        bodyparms,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  changeExternalManager(contractId, bodyparms) {
    return axios
      .patch(
        `${config["apiUrl"]}contracts/expiring/${contractId}/externalManager`,
        bodyparms,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getTicketsByEquipment(equipments) {
    return axios
      .post(
        `${config["apiUrl"]}equipments/searchTickets`,
        { equipments: equipments },
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  getTicketsByContract(contractId) {
    return axios
      .get(`${config["apiUrl"]}contracts/searchTickets/${contractId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countPendents(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = {...filters.filters };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/pendents/count`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getPendents(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = { ...params, ...filters.filters };
      }
      if (filters.sort != undefined) {
        params = { ...params, ...filters.sort };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/pendents`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  removePendingStatus(contractId) {
    return axios
      .patch(
        `${config["apiUrl"]}contracts/expiring/${contractId}/removePending`,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  setPending(contractId, bodyParams) {
    return axios
      .patch(
        `${config["apiUrl"]}contracts/expiring/${contractId}/setPending`,
        bodyParams,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  setDeactivate(contractId, bodyParams) {
    return axios
      .patch(
        `${config["apiUrl"]}contracts/expiring/${contractId}/deactivate`,
        bodyParams,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  removeDeactivate(contractId) {
    return axios
      .patch(
        `${config["apiUrl"]}contracts/expiring/${contractId}/deactivate/remove`,
        {},
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countDeactivate(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = {...filters.filters };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/deactivate/count`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getDeactivate(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = { ...params, ...filters.filters };
      }
      if (filters.sort != undefined) {
        params = { ...params, ...filters.sort };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/deactivate`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countInactive(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = {...filters.filters };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/inactive/count`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getInactive(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = { ...params, ...filters.filters };
      }
      if (filters.sort != undefined) {
        params = { ...params, ...filters.sort };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/inactive`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getAttachment(emailId, attachmentId) {
    return axios
      .get(
        `${config["apiUrl"]}contracts/expiring/email/${emailId}/attachment/${attachmentId}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status != undefined && response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countResendEmail(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = {...filters.filters };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/resendEmail/count`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getResendEmail(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = { ...params, ...filters.filters };
      }
      if (filters.sort != undefined) {
        params = { ...params, ...filters.sort };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/resendEmail`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countNeedResponse(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = {...filters.filters };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/needResponse/count`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getNeedResponse(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = { ...params, ...filters.filters };
      }
      if (filters.sort != undefined) {
        params = { ...params, ...filters.sort };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/needResponse`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  toggleNeedResponse(contractId, bodyParams) {
    return axios
      .patch(
        `${config["apiUrl"]}contracts/expiring/${contractId}/needResponse`,
        bodyParams,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  toggleResendEmail(contractId, bodyParams) {
    return axios
      .patch(
        `${config["apiUrl"]}contracts/expiring/${contractId}/resendEmail`,
        bodyParams,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getAllInfo(contractId) {
    return axios
      .get(`${config["apiUrl"]}contracts/${contractId}`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
  exportExcel(contractId) {
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/${contractId}/export`, {
        headers: authHeader(),
        responseType: "arraybuffer",
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  exportData( filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = { ...params, ...filters.filters };
      }
      if (filters.sort != undefined) {
        params = { ...params, ...filters.sort };
      }
      if (filters.mode != undefined) {
        params = { ...params, ...filters.mode };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expiring/export`, {
        headers: authHeader(),
        responseType: "arraybuffer",
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countExpiredToBeTreated(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = {...filters.filters };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expired/toBeTreated/count`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getExpiredToBeTreated(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = {...filters.filters };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expired/toBeTreated`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countExpiredWaitingResponse(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = {...filters.filters };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expired/waitingResponse/count`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getExpiredWaitingResponse(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = {...filters.filters };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expired/waitingResponse`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countExpiredWaitingResponseExpired(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = {...filters.filters };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expired/waitingResponse/expired/count`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getExpiredWaitingResponseExpired(filters) {
    let params = {};
    if (filters != undefined) {
      if (filters.filters != undefined) {
        params = {...filters.filters };
      }
    }
    return axios
      .get(`${config["apiUrl"]}contracts/expired/waitingResponse/expired`, {
        headers: authHeader(),
        params: params,
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  setWaitingResponse(bodyParams) {
    return axios
      .patch(
        `${config["apiUrl"]}contracts/expired/waitingResponse`,
        bodyParams,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  queryContracts(search, client) {
    return axios
      .get(`${config["apiUrl"]}contracts/query`, {
        params: { search, client },
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  openPats(contractId) {
    return axios
      .get(`${config["apiUrl"]}contracts/${contractId}/openPats`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getPats(contractId) {
    return axios
      .get(`${config["apiUrl"]}contracts/${contractId}/pats`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  toggleSellerValidation(contractId, bodyparms) {
    return axios
      .patch(
        `${config["apiUrl"]}contracts/${contractId}/sellerValidation`,
        bodyparms,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getWithoutSellerValidation() {
    return axios
      .get(`${config["apiUrl"]}contracts/withoutSellerValidation`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  countWithoutSellerValidation() {
    return axios
      .get(`${config["apiUrl"]}contracts/withoutSellerValidation/count`, {
        headers: authHeader(),
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  listContracts(search = "", filters = {}, options = {}) {
    const params = {};

    if (search && search.trim() !== "") {
      params.search = search.trim();
    }
    ["reference", "designation", "product", "description", "client", "seller", "segment", "sla", "sla_remote", "support_type", "entity", "location", "end_contract", "status"].forEach((key) => {
      if (filters[key]) params[key] = filters[key];
    });
    if (options.page) params.page = options.page;
    if (options.per_page) params.per_page = options.per_page;
    if (options.sort_field) params.sort_field = options.sort_field;
    if (options.sort_order) params.sort_order = options.sort_order;

    return axios
      .get(`${config["apiUrl"]}contracts/list`, {
        headers: authHeader(),
        params,
      })
      .then((response) => {
        if (response.status !== 200) return null;
        if (response.data && Array.isArray(response.data.data)) {
          const meta = response.data.meta || {};
          return {
            items: response.data.data,
            total: meta.total != null ? meta.total : response.data.data.length,
            perPage: meta.per_page != null ? Number(meta.per_page) : null,
            currentPage:
              meta.current_page != null ? Number(meta.current_page) : null,
          };
        }
        return { items: [], total: 0, perPage: null, currentPage: 1 };
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }
}
export default new Contracts();
